import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getBigcommerceIntegration = unaryRpc({
  name: "getBigcommerceIntegration" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ hasBigcommerceIntegration: z.boolean() }),
});
